import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visa-click-to-pay',
  templateUrl: './visa-click-to-pay.component.html',
  styleUrls: ['./visa-click-to-pay.component.scss']
})
export class VisaClickToPayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
